import { render, staticRenderFns } from "./CampaignUserUpload.vue?vue&type=template&id=422c2c62&scoped=true"
import script from "./CampaignUserUpload.vue?vue&type=script&lang=js"
export * from "./CampaignUserUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c2c62",
  null
  
)

export default component.exports